var _desc, _defs, _rect, _path, _path2, _g, _g2, _g3, _g4, _g5, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPoliticsbench(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1200,
    height: 675,
    viewBox: "0 0 1200 675",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "PoliticsBench project preview") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "An abstract benchmark dashboard with ballot cards, model nodes, and evaluation bars.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#211917"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4d2334"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#315c51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barPink",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3b7ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8d3151"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "barGreen",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c8decf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#315c51"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 24,
    stdDeviation: 22,
    floodColor: "#150f0e",
    floodOpacity: 0.26
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 675,
    fill: "url(#bg)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84 184c104-64 218-87 342-68 164 25 279 130 433 111 105-13 178-70 257-132",
    fill: "none",
    stroke: "#fffefa",
    strokeOpacity: 0.12,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98 496c144-98 288-114 432-47 146 68 272 75 389 23 76-34 132-86 202-154",
    fill: "none",
    stroke: "#fffefa",
    strokeOpacity: 0.1,
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 146,
    cy: 126,
    r: 4,
    fill: "#fffefa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 942,
    cy: 96,
    r: 5,
    fill: "#fffefa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1058,
    cy: 542,
    r: 4,
    fill: "#fffefa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 682,
    cy: 138,
    r: 3,
    fill: "#fffefa"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 554,
    r: 3,
    fill: "#fffefa"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 118,
    y: 128,
    width: 360,
    height: 420,
    rx: 18,
    fill: "#fffefa",
    fillOpacity: 0.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 172,
    width: 118,
    height: 18,
    rx: 9,
    fill: "#8d3151"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 218,
    width: 244,
    height: 18,
    rx: 9,
    fill: "#ded8d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 258,
    width: 192,
    height: 18,
    rx: 9,
    fill: "#ded8d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 326,
    width: 72,
    height: 72,
    rx: 10,
    fill: "#f3b7ba"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m176 360 20 20 44-52",
    fill: "none",
    stroke: "#211917",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 438,
    width: 248,
    height: 18,
    rx: 9,
    fill: "#c8decf"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 478,
    width: 176,
    height: 18,
    rx: 9,
    fill: "#ded8d0"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadow)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 724,
    y: 128,
    width: 360,
    height: 420,
    rx: 18,
    fill: "#fffefa",
    fillOpacity: 0.92
  }), /*#__PURE__*/React.createElement("rect", {
    x: 764,
    y: 184,
    width: 240,
    height: 22,
    rx: 11,
    fill: "#ded8d0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 764,
    y: 246,
    width: 188,
    height: 28,
    rx: 14,
    fill: "url(#barPink)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 764,
    y: 318,
    width: 260,
    height: 28,
    rx: 14,
    fill: "url(#barGreen)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 764,
    y: 390,
    width: 216,
    height: 28,
    rx: 14,
    fill: "#c58f38"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#211917",
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1028,
    cy: 260,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028,
    cy: 332,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1028,
    cy: 404,
    r: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M814 486h180",
    stroke: "#8d3151",
    strokeWidth: 12,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M814 486h126",
    stroke: "#315c51",
    strokeWidth: 12,
    strokeLinecap: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#fffefa",
    strokeOpacity: 0.28,
    strokeWidth: 3,
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M478 274c82-82 164-82 246 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 402c82 82 164 82 246 0"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#fffefa"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 338,
    r: 74,
    fillOpacity: 0.94
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 600,
    cy: 338,
    r: 46,
    fill: "#211917",
    fillOpacity: 0.92
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568 338h64M600 306v64",
    stroke: "#fffefa",
    strokeWidth: 10,
    strokeLinecap: "round"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 600,
    y: 602,
    fill: "#fffefa",
    fontFamily: "Georgia, 'Times New Roman', serif",
    fontSize: 64,
    textAnchor: "middle"
  }, "PoliticsBench")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliticsbench);
export default __webpack_public_path__ + "static/media/politicsbench.4a24243dfbcc55a4461cddb3a41ce27a.svg";
export { ForwardRef as ReactComponent };